import axios from 'axios';
import { baseUrl } from './urls'
import Cookies from 'js-cookie'

const instance = axios.create({
    baseURL: baseUrl+'/',
    headers : {
        Authorization : 'Bearer '+Cookies.get('ssotok') //ubah belakangan
    }
});

export default instance;